module.exports = __webpack_public_path__ + "img/80C.fa4e16ac.png";